import React from 'react';
import { PapiUser } from '@wix/da-types-papi';
import { useTranslation } from 'react-i18next';
import Button from '@wix/da-shared-react/pkg/Button';
import ElementQueries from '@wix/da-shared-react/pkg/ElementQueries';
import MiniProfileIdentity from '../_partials/MiniProfileIdentity';

import s from './WatchedDeviants.scss';

export type Watcher = PapiUser;

export interface Visitor extends PapiUser {
  isLoggedin: boolean;
}

export interface Props {
  moduleId: number;
  seeAllUrl: string;
  browseUrl: string;
  username: string;
  visitor: Visitor;
  deviants: Watcher[];
  canLoadMore?: boolean;
  isFetching?: boolean;
  fetchMore?: () => void;
  isHeaderStickyOnMobile?: boolean;
}

export const WatchedDeviants: React.FC<Props> = ({
  deviants,
  fetchMore,
  isFetching,
  canLoadMore,
}) => {
  const { t } = useTranslation();

  const renderGrid = () => (
    <ElementQueries widthBreakpoints={[640, 800]} className={s['grid']}>
      {deviants.map(renderGridElement)}
    </ElementQueries>
  );

  const renderGridElement = (watcher: Watcher) => {
    const { username } = watcher;
    return (
      <MiniProfileIdentity
        key={username}
        className={s['watcher']}
        user={watcher}
        withTooltip
      />
    );
  };

  return (
    <>
      {renderGrid()}
      {canLoadMore && (
        <Button
          view="b8"
          onClick={fetchMore}
          disabled={isFetching}
          className={s['load-more-button']}
        >
          {t('common.loadMore')}
        </Button>
      )}
    </>
  );
};

export default WatchedDeviants;
